<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script setup>
// import axios from "axios";
import Notiflix from "notiflix";
import { onMounted } from "vue";

// const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

async function wakeApi() {
// retries = 10, delayMs = 3000
  // let attempt = 0;
  // while (attempt < retries) {
  //   try {
  //     attempt++;
  //     console.log(`Intento ${attempt} de despertar API...`);
  //     await axios.post(`${process.env.VUE_APP_API_URL}/api/start`, null, {
  //       timeout: 60000,
  //     });
  //     console.log("API despertada correctamente");
  //     return; // éxito, sale de la función
  //   } catch (error) {
  //     console.warn(`Error en intento ${attempt}: ${error.message}`);
  //     if (attempt === retries) throw error; // re-lanza error tras últimos intentos
  //     await delay(delayMs);
  //   }
  // }
}

onMounted(async () => {
  Notiflix.Loading.init({
    //backgroundColor: 'rgba(0,0,0,0.9)',
    //svgColor: '#fff',
    svgSize: "100px",
    svgColor: "#f97316",
    clickToClose: false,
  });
  Notiflix.Loading.standard();

  try {
    await wakeApi();
  } catch (error) {
    console.error("No se pudo despertar la API:", error.message);
  } finally {
    Notiflix.Loading.remove();
  }
});
</script>
